<div class="radio-wrapper">
  <div *ngFor="let option of element.possibleValues" class="field-radiobutton">
    <p-radiobutton
      [name]="searchValue"
      [(ngModel)]="searchValue"
      [value]="option.value"
      [inputId]="option.value"
      (onClick)="handleChange($event)"
      [disabled]="disableField"
    ></p-radiobutton>
    <label class="ml-1 mr-2" [for]="option.value">{{ option.name }}</label>
  </div>
</div>
<div *ngIf="isLoading" class="acl-loader">
  <p-progress-spinner></p-progress-spinner>
</div>
<vb-index-designer
  [formData]="formData"
  [tableIdMap]="tableIdMap"
  [fieldIdMap]="fieldIdMap"
  [pickList]="pickList"
  [disableField]="disableField"
  [formFields]="formFields"
  [showTable]="false"
  (saveIndexEvent)="setValue($event)"
  [showDetail]="showCreateIndex"
  *ngIf="showCreateIndex"
></vb-index-designer>
